export const COMMON_GET_TAGS = "COMMON_GET_TAGS";
export const COMMON_UPDATE_TAG_LIST = "COMMON_UPDATE_TAG_LIST";

export const COMMON_DELETE_TAG = "COMMON_DELETE_TAG";
export const COMMON_UPDATE_TAG = "COMMON_UPDATE_TAG";

export const COMMON_NEW_TAG = "COMMON_NEW_TAG";
